import React, { Component } from 'react'

export default class CallAction extends Component {
  render() {
    return (
     <div>
  <section className="call-action">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6 col-12">
          <div className="text">
            <h2>Ready to dive in?<span>Start your Development Career today.</span>
            </h2>
          </div>
        </div>
        <div className="col-lg-6 col-12">
          <div className="button">
            <a href="registration.html" className="btn">Sign Up
            </a>
            <a href="faq.html" className="btn btn-alt">Learn More</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

    )
  }
}
